import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { ToasterService } from '../services/toaster.service';
import { RouterLink } from '@angular/router';
import { ProfileDataObj } from '../edit-profile/profile.modal';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-complete-registration',
  templateUrl: './complete-registration.component.html',
  styleUrls: ['./complete-registration.component.css'],
  providers: [ToasterService]
})
export class CompleteRegistrationComponent implements OnInit {

  profileData = new ProfileDataObj();
  loading: boolean;
  profileMaxDate = new Date();
  private onDestroy$: Subject<void> = new Subject<void>();
  isReadOnlyEmail=true;
  isReadOnlyMobile=true;
  type:any;

  constructor(private router: Router, private toasterService: ToasterService, private _location: Location, private serviceURLService: serviceURLService) {

  }

  ngOnInit() {
    this.getProfileDetails();
    if(!localStorage.getItem("email")){
      this.isReadOnlyEmail=false;
    }
    if(!localStorage.getItem("mobileNumber")){
      this.isReadOnlyMobile=false;
    }
  }

  getProfileDetails() {
    this.loading = true;
    let userID = localStorage.getItem('userID');
    this.serviceURLService.getProfileDetails(userID).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.profileData = successData.response.profileData;
      this.profileData.dob = successData.response.profileData.dob ? new Date(successData.response.profileData.dob) : '';
      if(successData.response.profileData.email){
        this.isReadOnlyEmail=true;
      }
      if(successData.response.profileData.mobile){
        this.isReadOnlyMobile=true;
      }
      if(this.isReadOnlyEmail){ 
        if(this.isReadOnlyMobile){
          this.type='edit-other'
        } else {
          this.type='edit-mobile'
        }
      } else if(this.isReadOnlyMobile){
        this.type='edit-email'
      } else{
        this.type='edit-other'
      }
    }, errorData => {
      this.loading = false;
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        //this.error = errorData.error.message;
        //console.log("ERROR: ",this.error);
      }
    });
  }


  updateProfileDetails() {
    this.loading = true;
    let sendProfileData = {
      "name": this.profileData.name,
      "mobile": this.profileData.mobile,
      "email": this.profileData.email,
      "dob": (new Date(this.profileData.dob).getTime()).toString(),
      "company": this.profileData.company,
      "family": '[]'
    }
    this.serviceURLService.setMobileEmailDetails(sendProfileData,this.type).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.toasterService.showErrorToaster(successData.message);
      // this (localstorage) code will be remove when we are done from code review point
      localStorage.setItem('name', successData.response.profileData.name);
      localStorage.setItem('mobileNumber', JSON.parse(successData.response.profileData.mobile));
      localStorage.setItem('email', successData.response.profileData.email);
      if(successData.response.profileData.email){
        this.isReadOnlyEmail=true;
      }
      if(successData.response.profileData.mobile){
        this.isReadOnlyMobile=true;
      }
      if(this.isReadOnlyEmail){ 
        if(this.isReadOnlyMobile){
          this.type='edit-other'
        } else {
          this.type='edit-mobile'
        }
      } else if(this.isReadOnlyMobile){
        this.type='edit-email'
      } else{
        this.type='edit-other'
      }
    }, errorData => {
      this.loading = false;
    });
  }

  goToHome(){
    this.router.navigate(['home']);
  }

  logOut(){
    localStorage.clear();
    this.router.navigate(['login']);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }

}
